// =============================================================
// SECTION 1A: PRODUCT PAGE SKU
// =============================================================
(function () {
  if (window.location.pathname.indexOf('/products/') === -1) return;

  function extractCode(text) {
    if (!text) return '';
    var matches = text.match(/\(([^)]+)\)/g) || [];
    for (var i = matches.length - 1; i >= 0; i--) {
      var inner = matches[i].replace(/[()]/g, '').trim();
      if (!inner) continue;
      if (inner.indexOf('Rs') !== -1) continue;
      if (inner.indexOf('+') !== -1 && /\d/.test(inner)) continue;
      if (/^\d+\.\d+$/.test(inner)) continue;
      return inner;
    }
    return '';
  }

  function getSelectedText(option) {
    var acc = option.querySelector('.mw-accumulated-title');
    if (acc && acc.textContent.trim()) return acc.textContent.trim();

    var selWrapper = option.querySelector(
      '.mw-option__value--selected, .mw-option__value--active, .mw-option__value.is-selected'
    );
    if (selWrapper) {
      var titleEl = selWrapper.querySelector('.mw-option__value-title, .mw-option__label, .mw-option__value-text');
      var raw = titleEl ? titleEl.textContent.trim() : selWrapper.textContent.trim();
      if (raw) return raw;
    }

    var customOpt = option.querySelector('.selectCustom-option.mw-selected, .selectCustom-option[aria-selected="true"]');
    if (customOpt) {
      var valEl = customOpt.querySelector('.mw-option__value-text, .mw-option__value-title');
      return valEl ? valEl.textContent.trim() : customOpt.textContent.trim();
    }

    var sel = option.querySelector('select');
    if (sel) {
      var opt = sel.options[sel.selectedIndex];
      if (opt && opt.value) return opt.text.trim();
    }

    var checked = option.querySelector('input[type="radio"]:checked, input[type="checkbox"]:checked');
    if (checked) {
      var lbl = checked.closest('label');
      if (!lbl && checked.id) lbl = document.querySelector('label[for="' + checked.id + '"]');
      if (lbl) { var lt = lbl.textContent.trim(); if (lt) return lt; }
      if (checked.value) return checked.value;
    }
    return '';
  }

  function buildSKU() {
    var base = '';
    var el = document.getElementById('product-base-sku');
    if (el) base = el.dataset.sku || '';
    var last = '';
    var lastEl = document.getElementById('product-last-sku');
    if (lastEl) last = lastEl.dataset.sku || '';
    var codes = [];
    document.querySelectorAll('.mw-option').forEach(function (option) {
      if (option.offsetParent === null) return; // skip hidden conditional options
      var text = getSelectedText(option);
      if (!text) return;
      var code = extractCode(text);
      if (code) codes.push(code);
    });
    return base + codes.join('') + last;
  }

  function updateDisplay() {
    var el = document.getElementById('apo-generated-sku');
    if (el) el.textContent = buildSKU() || '—';
  }

  function injectDisplay() {
    if (document.getElementById('apo-generated-sku')) return;
    var btn = document.querySelector('.mw-apo-add-to-cart-custom');
    if (!btn) return;

    if (!document.getElementById('apo-sku-style')) {
      var style = document.createElement('style');
      style.id = 'apo-sku-style';
      style.textContent =
        '.apo-sku-display{display:flex;align-items:center;gap:6px;margin:8px 0 12px;font-size:13px;}' +
        '.apo-sku-label{font-weight:600;color:#333;letter-spacing:.03em;}' +
        '#apo-generated-sku{font-family:monospace;font-size:13px;color:#111;letter-spacing:.04em;}';
      document.head.appendChild(style);
    }

    var wrapper = document.createElement('div');
    wrapper.className = 'apo-sku-display';
    wrapper.innerHTML = '<span class="apo-sku-label">SKU:</span><span id="apo-generated-sku">—</span>';
    btn.parentNode.insertBefore(wrapper, btn);
  }

  function bindListeners() {
    document.querySelectorAll('.mw-option').forEach(function (opt) {
      opt.addEventListener('click',  function () { setTimeout(updateDisplay, 100); });
      opt.addEventListener('change', function () { setTimeout(updateDisplay, 100); });
    });
    document.querySelectorAll('.mw-accumulated-title').forEach(function (el) {
      new MutationObserver(updateDisplay).observe(el, { childList: true, subtree: true, characterData: true });
    });
  }

  function watchRerender() {
    var section = document.querySelector('.shopify-section--main-product');
    if (!section) return;
    new MutationObserver(function () {
      if (!document.getElementById('apo-generated-sku')) {
        injectDisplay(); bindListeners(); updateDisplay();
      }
    }).observe(section, { childList: true, subtree: true });
  }

  function init() {
    watchRerender();
    if (!document.querySelector('.mw-apo-container')) return;
    injectDisplay();
    bindListeners();
    updateDisplay();
  }

  setTimeout(init, 800);
})();


// =============================================================
// SECTION 1B: CART PAGE SKU
// =============================================================
(function () {

  function extractCode(text) {
    if (!text) return '';
    var matches = text.match(/\(([^)]+)\)/g) || [];
    for (var i = matches.length - 1; i >= 0; i--) {
      var inner = matches[i].replace(/[()]/g, '').trim();
      if (!inner) continue;
      if (inner.indexOf('Rs') !== -1) continue;
      if (inner.indexOf('+') !== -1 && /\d/.test(inner)) continue;
      if (/^\d+\.\d+$/.test(inner)) continue;
      return inner;
    }
    return '';
  }

  function buildSKUForItem(item) {
    var base = item.sku || '';
    var codes = [];
    Object.keys(item.properties || {}).forEach(function (key) {
      if (key === 'SKU' || key.charAt(0) === '_') return;
      var code = extractCode(String(item.properties[key] || ''));
      if (code) codes.push(code);
    });
    return base + codes.join('');
  }

  function patchLineItem(itemKey, existingProps, newSKU) {
    var merged = Object.assign({}, existingProps, { SKU: newSKU });
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: itemKey, properties: merged })
    }).then(function (r) { return r.json(); });
  }

  function updateDOMSku(itemKey, sku) {
    document.querySelectorAll('[data-key="' + itemKey + '"]').forEach(function (row) {
      var existing = row.querySelector('.apo-cart-sku');
      if (existing) { existing.textContent = 'SKU: ' + sku; return; }
      var infoEl = row.querySelector('.line-item__info, .cart-item__details, .v-stack');
      if (infoEl) {
        var p = document.createElement('p');
        p.className = 'apo-cart-sku text-sm text-subdued';
        p.textContent = 'SKU: ' + sku;
        infoEl.appendChild(p);
      }
    });
    document.querySelectorAll('.text-sm.text-subdued').forEach(function (el) {
      if (el.textContent.trim().indexOf('SKU:') === 0) {
        el.textContent = 'SKU: ' + sku;
      }
    });
  }

  function syncCartSKUs() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        (cart.items || []).forEach(function (item) {
          var currentSKU = (item.properties || {})['SKU'] || '';
          var newSKU = buildSKUForItem(item);
          if (!newSKU) return;
          if (newSKU === currentSKU) { updateDOMSku(item.key, newSKU); return; }
          patchLineItem(item.properties || {}, newSKU)
            .then(function () { updateDOMSku(item.key, newSKU); })
            .catch(function (e) { console.warn('[Cart SKU] patch failed:', e); });
        });
      })
      .catch(function (e) { console.warn('[Cart SKU] fetch failed:', e); });
  }

  function init() {
    syncCartSKUs();
    document.addEventListener('shopify:section:load', syncCartSKUs);
    if (window.location.pathname.indexOf('/cart') !== -1) {
      document.addEventListener('submit', function () { setTimeout(syncCartSKUs, 900); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(init, 600); });
  } else {
    setTimeout(init, 600);
  }
})();


// =============================================================
// SECTION 2: GALLERY FILTER (Metafield-aware)
// =============================================================
(function () {

  function normalize(str) {
    if (!str) return '';
    return str
      .toLowerCase()
      .replace(/\(.*?\)/g, '')
      .replace(/\+.*$/g, '')
      .trim()
      .replace(/\s+/g, '-')
      .replace(/[^a-z0-9\-]/g, '');
  }

  // Whole-token match: true only if `key` appears in `haystack` bounded by
  // non-alphanumeric characters (or string edges), so a SKU like "02" does not
  // false-match inside a longer code like "020" or "102".
  function keyMatches(haystack, key) {
    if (!haystack || !key) return false;
    var esc = key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    var re = new RegExp('(^|[^a-z0-9])' + esc + '($|[^a-z0-9])', 'i');
    return re.test(haystack);
  }

  // True if EVERY key matches its own, non-overlapping segment of `haystack`. Each
  // matched segment is consumed so it can't satisfy another key — otherwise a Lotus
  // colour "white" would also match inside mesh key "bsa-white", making every
  // "BSA-white-<anything>" image match instead of only "BSA-white-white". Longest keys
  // are consumed first so a short key can't steal part of a longer one.
  function matchesAllKeys(haystack, keys) {
    if (!haystack || !keys.length) return false;
    // Mesh-seat images (e.g. "BN-Cyan-mesh-M-White") only belong to a Mesh selection.
    // Without this, Upholstered + Lotus "White"/"Blackish" also matches them, since
    // "upholstered" is dropped as a key and the remaining keys are a subset.
    if (keyMatches(haystack, 'mesh') && !keys.some(function (k) { return keyMatches(k, 'mesh'); })) {
      return false;
    }
    var rest = haystack.toLowerCase();
    var sorted = keys.slice().sort(function (a, b) { return b.length - a.length; });
    return sorted.every(function (key) {
      var esc = key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      var re = new RegExp('(^|[^a-z0-9])' + esc + '(?=$|[^a-z0-9])', 'i');
      if (!re.test(rest)) return false;
      rest = rest.replace(re, '$1 ');
      return true;
    });
  }

  // Selected values from the theme's own variant picker on the main product form
  // (quick-buy pickers are ignored).
  function getNativeVariantValues() {
    var values = [];
    document.querySelectorAll('variant-picker[form-id^="product-form-"]').forEach(function (picker) {
      picker.querySelectorAll('input[type="radio"]:checked').forEach(function (input) {
        var lbl = input.id && picker.querySelector('label[for="' + input.id + '"]');
        var t = lbl ? lbl.textContent.trim() : '';
        if (t) values.push(t);
      });
      picker.querySelectorAll('select').forEach(function (sel) {
        var opt = sel.options[sel.selectedIndex];
        if (opt && opt.value) values.push(opt.text.trim());
      });
    });
    return values;
  }

  function getKeysFromAPO() {
    var keys = [];

    // One title per option, so duplicates are kept on purpose: Mesh "White" + Lotus
    // "White" must yield ["white", "white"] and only match alts with white twice.
    document.querySelectorAll('.mw-accumulated-title').forEach(function (el) {
      var t = el.textContent.trim();
      if (t) {
        var k = normalize(t);
        if (k) keys.push(k);
      }
    });

    if (keys.length === 0) {
      document.querySelectorAll(
        '.mw-apo-container .selectCustom .selectCustom-option.mw-selected .mw-option__value-text'
      ).forEach(function (el) {
        var t = el.textContent.trim();
        if (t) {
          var k = normalize(t);
          if (k && keys.indexOf(k) === -1) keys.push(k);
        }
      });

      document.querySelectorAll('.mw-apo-container select.mw-option__control--type-select').forEach(function (sel) {
        var opt = sel.options[sel.selectedIndex];
        if (opt && opt.value) {
          var t = opt.text.trim();
          if (t) {
            var k = normalize(t);
            if (k && keys.indexOf(k) === -1) keys.push(k);
          }
        }
      });
    }

    // Native Shopify variant options (e.g. rental periods "3 months") — products with
    // no APO options would otherwise have no keys and every image would stay hidden.
    getNativeVariantValues().forEach(function (t) {
      var k = normalize(t);
      if (k && keys.indexOf(k) === -1) keys.push(k);
    });

    // Remove option-type labels (e.g. "fabric") that don't appear in any image alt or
    // metafield map key, so they don't block matching on products whose images ARE tagged
    // by option name. Only apply the filter when it keeps at least one key — if zero keys
    // would survive (e.g. products whose images use SKU codes instead of option names)
    // keep the original set so their gallery filtering still works.
    var refAlts = [];
    (window.defaultProductImages || []).forEach(function (img) {
      (img.alt || '').split(',').forEach(function (part) {
        var n = normalize(part);
        if (n) refAlts.push(n);
      });
    });
    refAlts = refAlts.concat(Object.keys(window.galleryMetafieldMap || {}).map(normalize));
    if (refAlts.length) {
      var filtered = keys.filter(function (k) {
        return refAlts.some(function (a) { return keyMatches(a, k); });
      });
      if (filtered.length > 0) keys = filtered;
    }

    console.log('Gallery Keys:', keys);
    return keys;
  }

  function altMatchesKeys(alt, keys) {
    return matchesAllKeys(alt, keys);
  }

  // Exact-match only: the generated SKU (from #apo-generated-sku, or rebuilt from the
  // selected option codes as a fallback) must equal an image's alt text exactly. No
  // partial/token matching — a mismatch means the image does not belong to this variant.
  function getExactSKU() {
    var skuEl = document.getElementById('apo-generated-sku');
    if (skuEl) {
      var t = skuEl.textContent.replace('—', '').trim();
      if (t) return t.toLowerCase();
    }
    var key = '';
    document.querySelectorAll('.mw-option').forEach(function (option) {
      var text = '';
      var sel = option.querySelector('select');
      if (sel) {
        var opt = sel.options[sel.selectedIndex];
        if (opt && opt.value) text = opt.text.trim();
      }
      if (!text) {
        var checked = option.querySelector('input[type=radio]:checked, input[type=checkbox]:checked');
        if (checked) {
          var lbl = option.querySelector('label[for="' + checked.id + '"]');
          if (lbl) text = lbl.textContent.trim();
        }
      }
      if (!text) {
        var acc = option.querySelector('.mw-accumulated-title');
        if (acc) text = acc.textContent.trim();
      }
      if (text) {
        var matches = text.match(/\(([^)]+)\)/g) || [];
        for (var i = matches.length - 1; i >= 0; i--) {
          var inner = matches[i].replace(/[()]/g, '').trim();
          if (!inner || inner.indexOf('Rs') !== -1) continue;
          if (inner.indexOf('+') !== -1 && /\d/.test(inner)) continue;
          if (/^\d+\.\d+$/.test(inner)) continue;
          key += inner;
          break;
        }
      }
    });
    return key.toLowerCase();
  }

  // Alt text may list several variants separated by commas, e.g.
  // "3-months-1,6-months-1,12-months-1,,18-months-1" — empty entries are ignored.
  function splitAlt(alt) {
    return (alt || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
  }

  function altExactMatchesSKU(alt, sku) {
    if (!sku) return false;
    return splitAlt(alt).some(function (part) { return part.toLowerCase() === sku; });
  }

  // An image is shown for the current selection if EITHER its alt text (or any
  // comma-separated entry in it) exactly equals the generated SKU, OR it matches
  // all of the selected option labels (whole-token match, so a partial digit
  // collision like "02" inside "020" never counts as a match). Both paths are
  // supported side by side so products tagged by SKU code and products tagged by
  // option label both work.
  function altMatchesSelection(alt, keys, sku) {
    if (altExactMatchesSKU(alt, sku)) return true;
    if (altMatchesKeys(alt, keys)) return true;
    return splitAlt(alt).some(function (part) { return altMatchesKeys(part, keys); });
  }

  function getMetafieldImages(keys, sku) {
    var map = window.galleryMetafieldMap || {};
    if (!Object.keys(map).length) return [];
    if (!keys.length && !sku) return [];

    var matched = [];
    Object.keys(map).forEach(function (mapKey) {
      var urls = map[mapKey] || [];
      var matchByKeys = matchesAllKeys(normalize(mapKey), keys);
      var matchBySKU = sku.length > 0 && mapKey.trim().toLowerCase() === sku;
      if (matchByKeys || matchBySKU) {
        urls.forEach(function (url) {
          if (matched.indexOf(url) === -1) matched.push(url);
        });
      }
    });

    console.log('Metafield images matched:', matched.length);
    return matched;
  }

  function injectMetafieldImages(urls) {
    document.querySelectorAll('.mf-injected').forEach(function (el) { el.remove(); });
    if (!urls.length) return;

    var carousel  = document.querySelector('media-carousel');
    var thumbList = document.querySelector('.product-gallery__thumbnail-list');
    var pageDots  = document.querySelector('.page-dots[aria-controls]');

    if (!carousel) { console.warn('media-carousel not found'); return; }

    urls.forEach(function (url, i) {
      var slide = document.createElement('div');
      slide.className = 'product-gallery__media snap-center mf-injected';
      slide.setAttribute('data-media-type', 'image');
      slide.setAttribute('data-media-id', 'mf-' + i);
      slide.setAttribute('data-alt', 'metafield-image');
      slide.innerHTML =
        '<div style="aspect-ratio:1/1;overflow:hidden;">' +
          '<img src="' + url + '" alt="Product image" loading="lazy"' +
          ' style="width:100%;height:100%;object-fit:contain;display:block;">' +
        '</div>';
      carousel.appendChild(slide);

      if (thumbList) {
        var thumb = document.createElement('button');
        thumb.type = 'button';
        thumb.className = 'product-gallery__thumbnail mf-injected';
        thumb.setAttribute('data-media-id', 'mf-' + i);
        thumb.setAttribute('data-alt', 'metafield-image');
        thumb.setAttribute('aria-current', 'false');
        thumb.setAttribute('aria-label', 'Product image ' + (i + 1));
        thumb.innerHTML =
          '<img src="' + url + '" alt="Product image" loading="lazy"' +
          ' style="width:100%;object-fit:contain;" class="object-contain rounded-sm">';
        thumb.addEventListener('click', function () {
          var allSlides = Array.from(carousel.querySelectorAll('.product-gallery__media:not([hidden])'));
          var slideIndex = allSlides.findIndex(function (s) { return s.getAttribute('data-media-id') === 'mf-' + i; });
          carousel.scrollTo({ left: carousel.offsetWidth * slideIndex, behavior: 'smooth' });
          document.querySelectorAll('.product-gallery__thumbnail').forEach(function (t) { t.setAttribute('aria-current', 'false'); });
          thumb.setAttribute('aria-current', 'true');
        });
        thumbList.appendChild(thumb);
      }

      if (pageDots) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'tap-area mf-injected';
        dot.setAttribute('aria-current', 'false');
        dot.innerHTML = '<span class="sr-only">Go to metafield image ' + (i + 1) + '</span>';
        pageDots.appendChild(dot);
      }
    });

    carousel.removeAttribute('adaptive-height');
    carousel.style.setProperty('max-height', 'none', 'important');
    carousel.style.setProperty('height', 'auto', 'important');

    new MutationObserver(function () {
      if (carousel.style.maxHeight === '0px' || carousel.style.maxHeight === '') {
        carousel.style.setProperty('max-height', 'none', 'important');
      }
    }).observe(carousel, { attributes: true, attributeFilter: ['style'] });

    requestAnimationFrame(function () {
      var allSlides = Array.from(carousel.querySelectorAll('.product-gallery__media:not([hidden])'));
      var firstMfIndex = allSlides.findIndex(function (s) { return s.classList.contains('mf-injected'); });
      if (firstMfIndex > 0) carousel.scrollTo({ left: carousel.offsetWidth * firstMfIndex, behavior: 'smooth' });
    });

    console.log('Injected', urls.length, 'metafield images');
  }

  // ── GALLERY PLACEHOLDER ──────────────────────────────────────

  function showGalleryPlaceholder() {
    if (document.getElementById('apo-gph')) return;

    var wrapper = document.querySelector('.product-gallery__media-list-wrapper');
    if (!wrapper) return;

    if (!document.getElementById('apo-gph-style')) {
      var s = document.createElement('style');
      s.id = 'apo-gph-style';
      s.textContent =
        '#apo-gph{' +
          'position:absolute;inset:0;z-index:3;' +
          'height:100vh;' +
          'display:flex;flex-direction:column;align-items:center;justify-content:center;gap:16px;' +
        '}' +
        '#apo-gph svg{animation:apo-gph-spin 1s linear infinite;width:72px;height:72px;}' +
        '#apo-gph p{' +
          'margin:0;text-align:center;color:#555;' +
          'font-size:15px;font-weight:500;letter-spacing:0.02em;line-height:1.5;' +
        '}' +
        '@media(max-width:740px){' +
          '#apo-gph svg{width:52px;height:52px;}' +
          '#apo-gph p{font-size:13px;}' +
          '#apo-gph{position:static;height:50vh;gap:12px;}' +
        '}' +
        '@keyframes apo-gph-spin{to{transform:rotate(360deg)}}';
      document.head.appendChild(s);
    }

    wrapper.style.position = 'relative';

    // 12-petal rainbow spinner matching the reference image
    var ph = document.createElement('div');
    ph.id = 'apo-gph';
    ph.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" width="72" height="72" viewBox="0 0 40 40">' +
        '<g transform="translate(20,20)">' +
          '<rect x="-2.4" y="-11" width="4.8" height="7.5" rx="2.4" fill="#F4A5B6" transform="rotate(0)"/>'   +
          '<rect x="-2.4" y="-11" width="4.8" height="7.5" rx="2.4" fill="#F2B97C" transform="rotate(30)"/>'  +
          '<rect x="-2.4" y="-11" width="4.8" height="7.5" rx="2.4" fill="#F0D478" transform="rotate(60)"/>'  +
          '<rect x="-2.4" y="-11" width="4.8" height="7.5" rx="2.4" fill="#C2DC88" transform="rotate(90)"/>'  +
          '<rect x="-2.4" y="-11" width="4.8" height="7.5" rx="2.4" fill="#80CCA0" transform="rotate(120)"/>' +
          '<rect x="-2.4" y="-11" width="4.8" height="7.5" rx="2.4" fill="#78BCE8" transform="rotate(150)"/>' +
          '<rect x="-2.4" y="-11" width="4.8" height="7.5" rx="2.4" fill="#9898E0" transform="rotate(180)"/>' +
          '<rect x="-2.4" y="-11" width="4.8" height="7.5" rx="2.4" fill="#C4A0D8" transform="rotate(210)"/>' +
          '<rect x="-2.4" y="-11" width="4.8" height="7.5" rx="2.4" fill="#E890BC" transform="rotate(240)"/>' +
          '<rect x="-2.4" y="-11" width="4.8" height="7.5" rx="2.4" fill="#F4A070" transform="rotate(270)"/>' +
          '<rect x="-2.4" y="-11" width="4.8" height="7.5" rx="2.4" fill="#ECC870" transform="rotate(300)"/>' +
          '<rect x="-2.4" y="-11" width="4.8" height="7.5" rx="2.4" fill="#D4E87C" transform="rotate(330)"/>' +
        '</g>' +
      '</svg>' +
      '<p>Please select a variant<br>to view images</p>';
    wrapper.appendChild(ph);
  }

  function removeGalleryPlaceholder() {
    var ph = document.getElementById('apo-gph');
    if (ph) ph.remove();
  }

  // ── IMAGE LIMIT ──────────────────────────────────────────────
  // "Limit gallery images" section setting: keep only the first N visible
  // slides/thumbnails and hide the rest. Page dots mirror the slides.

  function hideBeyondLimit(els, limit) {
    var count = 0;
    els.forEach(function (el) {
      if (el.hasAttribute('hidden')) return;
      count++;
      if (count > limit) el.setAttribute('hidden', 'hidden');
    });
  }

  function applyGalleryLimit() {
    var gallery = document.querySelector('product-gallery[data-image-limit]');
    if (!gallery) return;
    var limit = parseInt(gallery.getAttribute('data-image-limit'), 10);
    if (!limit) return;

    var slides = gallery.querySelectorAll('.product-gallery__media');
    hideBeyondLimit(slides, limit);
    hideBeyondLimit(gallery.querySelectorAll('.product-gallery__thumbnail'), limit);

    gallery.querySelectorAll('.page-dots[aria-controls] > button').forEach(function (dot, i) {
      if (slides[i]) dot.hidden = slides[i].hasAttribute('hidden');
    });
  }

  // ── FILTER ───────────────────────────────────────────────────

  function filterGallery() {
    var keys = getKeysFromAPO();
    var sku = getExactSKU();
    var hasSelection = keys.length > 0 || sku.length > 0;

    // Non-APO products (no APO options and no native variant picker, e.g. a single
    // "Default Title" variant) have nothing to select, so keep the default gallery
    // instead of hiding every image behind the "select a variant" placeholder.
    var hasOptions = document.querySelector('.mw-option, variant-picker[form-id^="product-form-"]');
    if (!hasSelection && !hasOptions) {
      // Images flagged with "@hide" in their alt text stay hidden
      document.querySelectorAll('.product-gallery__media:not([data-gallery-hidden]), .product-gallery__thumbnail:not([data-gallery-hidden])').forEach(function (el) {
        el.removeAttribute('hidden');
      });
      applyGalleryLimit();
      removeGalleryPlaceholder();
      return;
    }

    document.querySelectorAll('.product-gallery__media:not(.mf-injected)').forEach(function (el) {
      var alt = el.getAttribute('data-alt') || '';
      if (hasSelection && !el.hasAttribute('data-gallery-hidden') && altMatchesSelection(alt, keys, sku)) el.removeAttribute('hidden');
      else el.setAttribute('hidden', 'hidden');
    });
    document.querySelectorAll('.product-gallery__thumbnail:not(.mf-injected)').forEach(function (el) {
      var alt = el.getAttribute('data-alt') || '';
      if (hasSelection && !el.hasAttribute('data-gallery-hidden') && altMatchesSelection(alt, keys, sku)) el.removeAttribute('hidden');
      else el.setAttribute('hidden', 'hidden');
    });

    // Inject metafield images first (they may add visible slides)
    injectMetafieldImages(getMetafieldImages(keys, sku));
    applyGalleryLimit();

    // After DOM settles: show placeholder if empty, or scroll to first image
    requestAnimationFrame(function () {
      var totalVisible = document.querySelectorAll('.product-gallery__media:not([hidden])').length;

      if (totalVisible === 0) {
        showGalleryPlaceholder();
      } else {
        removeGalleryPlaceholder();
        var carousel = document.querySelector('media-carousel');
        if (!carousel) return;
        var visible = carousel.visibleItems;
        if (!visible || !visible.length) return;
        var firstIdx = carousel.items.indexOf(visible[0]);
        if (firstIdx >= 0) carousel.select(firstIdx, { animate: false });
      }
    });
  }

  function refreshGallery() { filterGallery(); }

  document.addEventListener('click',  function (e) { if (e.target.closest('.mw-apo-container')) setTimeout(refreshGallery, 150); });
  document.addEventListener('change', function (e) { if (e.target.closest('.mw-apo-container')) setTimeout(refreshGallery, 150); });
  // Native variant picker: theme fires variant:change on the form (bubbles), and may
  // re-render the gallery afterwards, so refresh once more after that settles.
  document.addEventListener('variant:change', function (e) {
    if (!e.target.id || e.target.id.indexOf('product-form-') !== 0) return;
    setTimeout(refreshGallery, 150);
    setTimeout(refreshGallery, 600);
  });

  document.addEventListener('DOMContentLoaded', function () {
    // Retry at increasing intervals: APO may finish setting its defaults after 1s.
    // Each attempt reads the current selection state; once keys appear, the gallery
    // filters correctly and subsequent identical runs are idempotent.
    [1000, 2000, 3500].forEach(function (delay) {
      setTimeout(refreshGallery, delay);
    });

    // Also watch the APO container for its first mutation (default values being set)
    // and trigger one extra refresh so the gallery updates as soon as APO is ready.
    var apoNode = document.querySelector('.mw-apo-container');
    if (apoNode) {
      var firstMutationDone = false;
      var initObserver = new MutationObserver(function () {
        if (firstMutationDone) return;
        firstMutationDone = true;
        initObserver.disconnect();
        setTimeout(refreshGallery, 200);
      });
      initObserver.observe(apoNode, { childList: true, subtree: true, characterData: true });
    }
  });
})();


// =============================================================
// SECTION 3: PRICE UPDATER
// =============================================================
(function () {

  function parseMoney(text) {
    if (!text) return 0;
    var match = text.match(/(\d[\d,]*\.?\d*)/);
    return match ? parseFloat(match[1].replace(/,/g, '')) : 0;
  }

  function formatMoney(value) {
    var n = Math.round(value);
    var s = n.toString();
    // Indian number format: last 3 digits, then groups of 2
    if (s.length > 3) {
      var last3 = s.slice(-3);
      var rest = s.slice(0, -3).replace(/\B(?=(\d{2})+(?!\d))/g, ',');
      s = rest + ',' + last3;
    }
    return '₹' + s;
  }

  function getBasePrice() {
    var el =
      document.querySelector('[data-product-price]') ||
      document.querySelector('.price .price__current') ||
      document.querySelector('.product-price') ||
      document.querySelector('.price');
    return el ? parseMoney(el.textContent) : 0;
  }

  function setDisplayedPrice(newPrice) {
    [
      document.querySelector('[data-product-price]'),
      document.querySelector('.price .price__current'),
      document.querySelector('.product-price'),
      document.querySelector('.price')
    ].filter(Boolean).forEach(function (el) { el.textContent = formatMoney(newPrice); });
  }

  function getApoPriceDelta() {
    var delta = 0;
    document.querySelectorAll(
      '.mw-apo-container .mw-option__value--selected, .mw-apo-container .selectCustom .mw-selected'
    ).forEach(function (el) {
      var priceEl = el.querySelector('.mw-option__price') || el.querySelector('.mw-price');
      if (priceEl) delta += parseMoney(priceEl.textContent || '');
    });
    return delta;
  }

  var basePriceCache = null;

  function updatePrice() {
    if (basePriceCache === null) basePriceCache = getBasePrice();
    setDisplayedPrice(basePriceCache + getApoPriceDelta());
  }

  document.addEventListener('click',  function (e) { if (e.target.closest('.mw-apo-container')) setTimeout(updatePrice, 150); });
  document.addEventListener('change', function (e) { if (e.target.closest('.mw-apo-container')) setTimeout(updatePrice, 150); });
  document.addEventListener('DOMContentLoaded', function () { setTimeout(updatePrice, 400); });
})();


// =============================================================
// SECTION 4: APO OPTIONS PERSISTENCE
// Saves APO dropdown selections to localStorage so they survive
// page refresh. Restores by setting <select> values + change event.
// =============================================================
(function () {
  if (window.location.pathname.indexOf('/products/') === -1) return;

  var handle = window.location.pathname.split('/products/')[1].split(/[?#]/)[0].split('/')[0];
  var LS_KEY = '_apo_opts_' + handle;

  function saveSelections() {
    var data = {};
    document.querySelectorAll('.mw-apo-container select').forEach(function (sel, i) {
      if (sel.value) data[i] = sel.value;
    });
    if (Object.keys(data).length) localStorage.setItem(LS_KEY, JSON.stringify(data));
  }

  function restoreSelections() {
    var stored;
    try { stored = JSON.parse(localStorage.getItem(LS_KEY)); } catch (e) {}
    if (!stored) return false;
    var selects = document.querySelectorAll('.mw-apo-container select');
    if (!selects.length) return false;
    selects.forEach(function (sel, i) {
      var val = stored[i];
      if (!val || sel.value === val) return;
      var exists = Array.from(sel.options).some(function (o) { return o.value === val; });
      if (exists) { sel.value = val; sel.dispatchEvent(new Event('change', { bubbles: true })); }
    });
    return true;
  }

  document.addEventListener('change', function (e) {
    if (e.target.closest('.mw-apo-container')) setTimeout(saveSelections, 150);
  });
  document.addEventListener('click', function (e) {
    if (e.target.closest('.mw-apo-container')) setTimeout(saveSelections, 300);
  });

  document.addEventListener('DOMContentLoaded', function () {
    var tries = 0;
    var t = setInterval(function () {
      if (restoreSelections() || ++tries >= 20) clearInterval(t);
    }, 200);
  });
})();


// =============================================================
// SECTION 5: APO CART IMAGE CAPTURE
// Saves visible gallery image to localStorage on add-to-cart click.
// Restores it on cart page and cart drawer via DOM swap.
// Also persists via /cart/change.js for Liquid line-item.liquid.
// =============================================================
(function () {
  var _pendingUrl = null;
  var LS_KEY = '_apo_img';

  function captureCurrentImage() {
    var slides = document.querySelectorAll('.product-gallery__media:not([hidden])');
    for (var i = 0; i < slides.length; i++) {
      var img = slides[i].querySelector('img');
      if (img && img.src) { _pendingUrl = img.src; return; }
    }
    var any = document.querySelector('.product-gallery__media img');
    if (any && any.src) _pendingUrl = any.src;
  }

  document.addEventListener('click',  function (e) { if (e.target.closest('.mw-apo-container')) setTimeout(captureCurrentImage, 200); });
  document.addEventListener('change', function (e) { if (e.target.closest('.mw-apo-container')) setTimeout(captureCurrentImage, 200); });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.mw-apo-add-to-cart-custom, [name="add"], [data-add-to-cart]');
    if (!btn) return;
    captureCurrentImage();
    if (!_pendingUrl) return;
    try {
      var h = window.location.pathname.split('/products/')[1];
      if (!h) return;
      h = h.split('?')[0].split('#')[0].split('/')[0];
      var map = JSON.parse(localStorage.getItem(LS_KEY) || '{}');
      map[h] = _pendingUrl;
      localStorage.setItem(LS_KEY, JSON.stringify(map));
    } catch (err) {}
  }, true);

  function applyToCartPage() {
    if (window.location.pathname.indexOf('/cart') === -1) return;
    try {
      var map = JSON.parse(localStorage.getItem(LS_KEY) || '{}');
      if (!Object.keys(map).length) return;
      document.querySelectorAll('.line-item').forEach(function (item) {
        var link = item.querySelector('a[href*="/products/"]');
        if (!link) return;
        var m = (link.getAttribute('href') || '').match(/\/products\/([^?#\/]+)/);
        if (!m) return;
        var url = map[m[1]];
        if (!url) return;
        var img = item.querySelector('.line-item__media');
        if (img) { img.src = url; img.srcset = ''; img.sizes = ''; }
      });
    } catch (err) {}
  }

  function applyToCartDrawer(imageUrl) {
    if (!imageUrl) return;
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var items = drawer.querySelectorAll('.line-item');
    if (!items.length) return;
    var last = items[items.length - 1];
    var img = last.querySelector('.line-item__media');
    if (img) { img.src = imageUrl; img.srcset = ''; img.sizes = ''; }
  }

  function patchCartItemImage(imageUrl) {
    if (!imageUrl) return;
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        var target = null;
        for (var i = items.length - 1; i >= 0; i--) {
          if (!(items[i].properties || {})['_cart_image']) { target = items[i]; break; }
        }
        if (!target) return;
        var props = Object.assign({}, target.properties || {}, { '_cart_image': imageUrl });
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: target.key, properties: props })
        }).catch(function () {});
      }).catch(function () {});
  }

  document.documentElement.addEventListener('cart:change', function (e) {
    var d = (e && e.detail) || {};
    if (d.baseEvent !== 'variant:add' || !_pendingUrl) return;
    var url = _pendingUrl;
    setTimeout(function () { applyToCartDrawer(url); }, 80);
    patchCartItemImage(url);
  });

  var _obs = null, _lastCount = 0;
  function observeDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || _obs) return;
    _obs = new MutationObserver(function () {
      var items = drawer.querySelectorAll('.line-item');
      if (items.length > _lastCount && _pendingUrl) {
        _lastCount = items.length;
        applyToCartDrawer(_pendingUrl);
        patchCartItemImage(_pendingUrl);
      }
    });
    _obs.observe(drawer, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(captureCurrentImage, 1500);
    observeDrawer();
    applyToCartPage();
  });

  document.addEventListener('shopify:section:load', function () {
    _obs = null; observeDrawer(); applyToCartPage();
  });
})();


// =============================================================
// SECTION 7: SPEC SHEET LINK (Metafield-aware)
// Reads custom.spec_sheets JSON metafield { "Option Value or SKU": "pdf-url" }
// Shows "View Spec Sheet" button when the selected SKU code matches a key
// exactly, or else when the selected APO option value matches a key;
// opens the PDF in a new tab.
// =============================================================
(function () {
  if (window.location.pathname.indexOf('/products/') === -1) return;

  // Converts "Standard B-relay" → "standard-b-relay" for consistent key matching.
  function normalizeKey(text) {
    if (!text) return '';
    return text
      .replace(/\s*\(\s*[+-]?\s*Rs\.?[^)]*\)/gi, '') // strip price modifiers
      .replace(/\(.*?\)/g, '')                         // strip remaining parens
      .replace(/\+.*$/g, '')                           // strip + addons
      .toLowerCase()
      .trim()
      .replace(/\s+/g, '-')
      .replace(/[^a-z0-9\-]/g, '');
  }

  function getSelectedValues() {
    var values = [];
    var seen = {};

    function add(raw) {
      var t = normalizeKey(raw);
      if (t && !seen[t]) { seen[t] = 1; values.push(t); }
    }

    // 1. APO accumulated titles — shown inline next to option heading e.g. "Standard B-relay (02)"
    document.querySelectorAll('.mw-accumulated-title').forEach(function (el) {
      add(el.textContent.trim());
    });

    // 2. APO swatch / block selected wrappers — text label or data-title
    document.querySelectorAll(
      '.mw-option__value--selected, .mw-option__value--active,' +
      '.mw-option__value.is-selected,' +
      '.mw-option__value[data-selected="true"],' +
      '.selectCustom-option.mw-selected,' +
      '.selectCustom-option[aria-selected="true"]'
    ).forEach(function (el) {
      // visible text label inside the swatch element
      var titleEl = el.querySelector('.mw-option__value-title, .mw-option__label, .mw-option__value-text');
      add(titleEl ? titleEl.textContent.trim() : el.textContent.trim());
      // data attributes APO uses for color circle swatches
      add(el.getAttribute('data-title') || '');
      add(el.getAttribute('data-value') || '');
      add(el.getAttribute('title') || '');
    });

    // 3. APO selects (dropdown)
    document.querySelectorAll('.mw-apo-container select').forEach(function (sel) {
      var opt = sel.options[sel.selectedIndex];
      if (opt && opt.value) add(opt.text.trim());
    });

    // 4. APO radio / checkbox inputs
    document.querySelectorAll(
      '.mw-apo-container input[type="radio"]:checked,' +
      '.mw-apo-container input[type="checkbox"]:checked'
    ).forEach(function (input) {
      var lbl = input.closest('label') ||
                (input.id && document.querySelector('label[for="' + input.id + '"]'));
      add(lbl ? lbl.textContent.trim() : (input.value || ''));
      add(input.getAttribute('data-title') || '');
    });

    console.log('[SpecSheet] selected values (normalized):', values);
    return values;
  }

  // SKU codes for the current selection, lowercased: the full generated SKU
  // (SECTION 1A) plus each per-value SKU shown under the options (SECTION 11).
  function getSelectedSkus() {
    var skus = [];
    function add(raw) {
      var t = (raw || '').trim().toLowerCase();
      if (t && skus.indexOf(t) === -1) skus.push(t);
    }
    var skuEl = document.getElementById('apo-generated-sku');
    if (skuEl) add(skuEl.textContent.replace('—', ''));
    document.querySelectorAll('.apo-value-sku').forEach(function (el) {
      el.textContent.replace(/^SKU:\s*/, '').split(',').forEach(add);
    });
    console.log('[SpecSheet] selected SKUs:', skus);
    return skus;
  }

  function findSpecSheetUrl(values, skus) {
    var map = window.specSheetMap;
    if (!map || typeof map !== 'object') {
      console.log('[SpecSheet] window.specSheetMap is not defined — metafield may not be set on this product');
      return null;
    }
    var mapKeys = Object.keys(map);

    // Exact SKU match takes priority — compared on the raw key (trimmed,
    // case-insensitive), not normalizeKey, so SKU codes are never altered.
    for (var s = 0; s < skus.length; s++) {
      for (var m = 0; m < mapKeys.length; m++) {
        if (mapKeys[m].trim().toLowerCase() === skus[s]) return map[mapKeys[m]];
      }
    }

    var normalizedMapKeys = mapKeys.map(normalizeKey);
    console.log('[SpecSheet] map keys (normalized):', normalizedMapKeys);

    // Candidate keys checked in priority order:
    // 1) each selected value on its own — covers products with a single combined
    //    swatch option whose value already is the full key, e.g. "Textile-GT-Relay"
    // 2) adjacent selected-value pairs joined together (both orders) — covers
    //    products with separate "Mesh Color" + "Textile Colour" options whose
    //    combination is the key, e.g. "BA-Black" + "Relay" -> "ba-black-relay"
    var candidates = values.slice();
    for (var k = 0; k < values.length - 1; k++) {
      candidates.push(values[k] + '-' + values[k + 1]);
      candidates.push(values[k + 1] + '-' + values[k]);
    }
    console.log('[SpecSheet] candidate keys (incl. combos):', candidates);

    for (var i = 0; i < candidates.length; i++) {
      for (var j = 0; j < normalizedMapKeys.length; j++) {
        if (normalizedMapKeys[j] === candidates[i]) return map[mapKeys[j]];
      }
    }
    return null;
  }

  function updateSpecSheet() {
    var container = document.getElementById('spec-sheet-action');
    var link = document.getElementById('spec-sheet-btn');
    if (!container || !link) {
      console.log('[SpecSheet] button element not found in DOM — metafield may not be set on this product');
      return;
    }
    var url = findSpecSheetUrl(getSelectedValues(), getSelectedSkus());
    if (url) {
      link.href = url;
      container.removeAttribute('hidden');
    } else {
      container.setAttribute('hidden', '');
    }
  }

  document.addEventListener('click',  function (e) {
    if (e.target.closest('.mw-apo-container')) setTimeout(updateSpecSheet, 150);
  });
  document.addEventListener('change', function (e) {
    if (e.target.closest('.mw-apo-container')) setTimeout(updateSpecSheet, 150);
  });

  document.addEventListener('DOMContentLoaded', function () {
    [1000, 2000, 3500].forEach(function (d) { setTimeout(updateSpecSheet, d); });
    var apoNode = document.querySelector('.mw-apo-container');
    if (apoNode) {
      // Keep observing (don't disconnect) so every APO mutation triggers a re-check
      new MutationObserver(function () {
        setTimeout(updateSpecSheet, 150);
      }).observe(apoNode, { childList: true, subtree: true, characterData: true });
    }
  });
})();


// =============================================================
// SECTION 6: IMPACT TEXT LOOPING COUNT-UP
// Reads the ORIGINAL number from data-loop-title (set in Liquid,
// never mutated by JS) so it is never fooled by mid-animation DOM.
// Sequence: theme counts 0→target once → pause 2s → our loop
// takes over: 0→target → pause 2s → 0→target → forever.
// =============================================================
(function () {
  var PAUSE_MS = 2000;

  function easeOut(t) { return 1 - Math.pow(1 - t, 3); }

  // ── ANIMATION ────────────────────────────────────────────────

  function animateCycle(span, target, label, durationMs, onDone) {
    var t0 = null;
    span.textContent = '0';
    function step(ts) {
      if (!t0) t0 = ts;
      var p = Math.min((ts - t0) / durationMs, 1);
      span.textContent = (p === 1) ? label : Math.round(easeOut(p) * target).toLocaleString('en-US');
      (p < 1) ? requestAnimationFrame(step) : onDone();
    }
    requestAnimationFrame(step);
  }

  function loop(span, target, label, durationMs) {
    animateCycle(span, target, label, durationMs, function () {
      setTimeout(function () { loop(span, target, label, durationMs); }, PAUSE_MS);
    });
  }

  // ── SETUP ────────────────────────────────────────────────────

  function setup(impactEl) {
    if (impactEl.dataset.loopDone) return;

    // data-loop-title is written by Liquid — always the original text
    var title = impactEl.dataset.loopTitle || '';
    var m     = title.match(/[\d,\.]+/);
    if (!m) return;
    var target = parseInt(m[0].replace(/[,\.]/g, ''), 10);
    if (isNaN(target) || target < 10000) return;
    var label  = target.toLocaleString('en-US');  // e.g. "500,000"

    var animMs = parseFloat(impactEl.getAttribute('count-up') || '2') * 1000;

    impactEl.dataset.loopDone = '1';

    // Wait for theme's one-shot count-up to finish, then take over
    setTimeout(function () {
      // Find the span the theme injected, or inject one ourselves
      var container = (impactEl.childElementCount === 0) ? impactEl : impactEl.firstElementChild;
      if (!container) return;

      var span = container.querySelector('span');
      if (!span) {
        // count-up was disabled or prefers-reduced-motion blocked it — inject our own span
        var original = container.innerHTML;
        container.innerHTML = original.replace(m[0], '<span data-loop-span>' + label + '</span>');
        span = container.querySelector('[data-loop-span]');
      }
      if (!span) return;

      loop(span, target, label, animMs);
    }, animMs + PAUSE_MS);
  }

  // ── INIT ─────────────────────────────────────────────────────

  function init() {
    document.querySelectorAll('impact-text[data-loop-title]').forEach(function (el) {
      setup(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


// =============================================================
// SECTION 8: GLOBAL PRICE FORMATTER (Indian number system)
// Reformats all Shopify-rendered prices (sale-price, compare-at-price)
// from e.g. "₹ 1,98,829.00" → "₹ 1,98,829" (no decimals, lakh commas)
// =============================================================
(function () {
  function toIndianFormat(num) {
    var n = Math.round(num);
    var s = n.toString();
    if (s.length > 3) {
      var last3 = s.slice(-3);
      var rest = s.slice(0, -3).replace(/\B(?=(\d{2})+(?!\d))/g, ',');
      s = rest + ',' + last3;
    }
    return s;
  }

  function reformatPriceEl(el) {
    // Collect text nodes only (skip .sr-only spans)
    var nodes = [];
    el.childNodes.forEach(function (n) {
      if (n.nodeType === Node.TEXT_NODE) nodes.push(n);
    });
    // Also handle direct text with no child text nodes (e.g. bare text in element)
    var raw = '';
    nodes.forEach(function (n) { raw += n.textContent; });
    if (!raw.trim()) {
      // fallback: grab full text minus sr-only
      el.querySelectorAll('.sr-only').forEach(function (s) { s.remove(); });
      raw = el.textContent;
    }

    var m = raw.match(/[\d,]+\.?\d*/);
    if (!m) return;
    var val = parseFloat(m[0].replace(/,/g, ''));
    if (isNaN(val)) return;

    // Detect currency symbol prefix
    var symbol = raw.replace(/[\d,\.\s]+/g, '').trim() || '₹';

    // Replace text node content
    nodes.forEach(function (n, i) {
      if (i === 0) n.textContent = symbol + ' ' + toIndianFormat(val);
      else n.textContent = '';
    });
  }

  function reformatAll() {
    document.querySelectorAll('sale-price, compare-at-price').forEach(function (el) {
      if (el.dataset.fmtDone) return;
      el.dataset.fmtDone = '1';
      reformatPriceEl(el);
    });
  }

  // Run on load and watch for dynamically added price elements
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reformatAll);
  } else {
    reformatAll();
  }

  // Re-run when new content loads (infinite scroll, quick view, etc.)
  new MutationObserver(function (mutations) {
    var hasNew = mutations.some(function (m) {
      return Array.from(m.addedNodes).some(function (n) {
        return n.nodeType === 1 && (
          n.matches('sale-price,compare-at-price') ||
          n.querySelector('sale-price,compare-at-price')
        );
      });
    });
    if (hasNew) reformatAll();
  }).observe(document.body, { childList: true, subtree: true });
})();


// =============================================================
// SECTION 9: APO RENTAL PROPERTY PATCH
// The "Rental" line-item property is normally set via a hidden
// form input in buy-buttons(-rental).liquid, but the APO add-to-cart
// button issues its own add-to-cart request that redirects the
// browser straight to a full /cart page load (confirmed: no cart
// drawer, no in-page 'cart:change' event) rather than an in-page
// AJAX add. An in-memory flag can't survive that navigation, so
// this uses localStorage instead - same idea as SECTION 5's
// _cart_image map, but checked unconditionally on every page load
// (a no-op when there's no pending flag) so it also catches the
// add on whatever page the browser lands on next (typically /cart).
// =============================================================
(function () {
  var LS_KEY = '_pending_rental_flag';
  var MAX_AGE_MS = 5 * 60 * 1000;

  document.addEventListener('click', function (e) {
    if (window.__isRentalProduct === true && e.target.closest('.mw-apo-add-to-cart-custom, [name="add"], [data-add-to-cart]')) {
      try { localStorage.setItem(LS_KEY, String(Date.now())); } catch (err) {}
    }
  }, true);

  function patchRentalProperty() {
    var stamp;
    try { stamp = localStorage.getItem(LS_KEY); } catch (err) { return; }
    if (!stamp) return;
    if (Date.now() - Number(stamp) > MAX_AGE_MS) {
      try { localStorage.removeItem(LS_KEY); } catch (err) {}
      return;
    }
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        var target = null;
        for (var i = items.length - 1; i >= 0; i--) {
          if (!(items[i].properties || {})['Rental']) { target = items[i]; break; }
        }
        if (!target) return;
        try { localStorage.removeItem(LS_KEY); } catch (err) {}
        var props = Object.assign({}, target.properties || {}, { 'Rental': 'True' });
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: target.key, properties: props })
        }).then(function () {
          updateDOMRentalProperty(target.key);
        }).catch(function () {});
      }).catch(function () {});
  }

  // Patches the already-rendered cart page/drawer in place so "Rental: True"
  // shows immediately, instead of only appearing after the next page load
  // (mirrors the SECTION 1B updateDOMSku approach for the same reason: the
  // /cart/change.js call above updates the server, not the page already sent
  // to the browser).
  function updateDOMRentalProperty(itemKey) {
    document.querySelectorAll('[data-key="' + itemKey + '"]').forEach(function (row) {
      var list = row.querySelector('.list-disc');
      if (!list) {
        var infoEl = row.querySelector('.line-item__info, .cart-item__details, .v-stack');
        if (!infoEl) return;
        list = document.createElement('ul');
        list.className = 'list-disc';
        infoEl.appendChild(list);
      }
      var already = Array.from(list.querySelectorAll('li')).some(function (li) {
        return li.textContent.trim().indexOf('Rental:') === 0;
      });
      if (already) return;
      var li = document.createElement('li');
      li.className = 'text-sm text-subdued';
      li.textContent = 'Rental: True';
      list.appendChild(li);
    });
  }

  document.documentElement.addEventListener('cart:change', function (e) {
    var d = (e && e.detail) || {};
    if (d.baseEvent !== 'variant:add') return;
    setTimeout(patchRentalProperty, 150);
  });

  var _obs = null, _lastCount = 0;
  function observeDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || _obs) return;
    _obs = new MutationObserver(function () {
      var items = drawer.querySelectorAll('.line-item');
      if (items.length > _lastCount) {
        _lastCount = items.length;
        patchRentalProperty();
      }
    });
    _obs.observe(drawer, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', function () {
    observeDrawer();
    patchRentalProperty();
  });
  document.addEventListener('shopify:section:load', function () { _obs = null; observeDrawer(); });
})();


// =============================================================
// SECTION 10: SHORTEN SWATCH OPTION LABEL DISPLAY
// The APO "accumulated title" shown next to a swatch option name
// (e.g. "Sprint Colors: Standard BT-Relay (02)") is also read verbatim
// by SECTION 1A (SKU), SECTION 2 (gallery filter) and SECTION 7 (spec
// sheet) to extract "(code)" and build matching keys, so we must NOT
// mutate its text. Instead we hide the original (still fully readable
// via .textContent by those other sections) and show a cloned sibling
// with only the last hyphen-separated word, keeping the trailing
// "(code)", e.g. "Standard BT-Relay (02)" -> "Relay (02)"
// =============================================================
(function () {
  if (window.location.pathname.indexOf('/products/') === -1) return;

  function shorten(rawText) {
    var text = (rawText || '').trim();
    if (!text) return null;
    var codeMatch = text.match(/\([^)]*\)\s*$/);
    var code = codeMatch ? codeMatch[0].trim() : '';
    var withoutCode = code ? text.slice(0, codeMatch.index).trim() : text;
    if (withoutCode.indexOf('-') === -1) return null;
    var parts = withoutCode.split('-');
    var lastWord = parts[parts.length - 1].trim();
    if (!lastWord || lastWord === withoutCode) return null;
    return code ? (lastWord + ' ' + code) : lastWord;
  }

  function getMirror(el) {
    var mirror = el.nextElementSibling;
    if (mirror && mirror.classList && mirror.classList.contains('mw-accumulated-title-short')) return mirror;
    mirror = el.cloneNode(false);
    mirror.classList.remove('mw-accumulated-title');
    mirror.classList.add('mw-accumulated-title-short');
    mirror.removeAttribute('id');
    el.insertAdjacentElement('afterend', mirror);
    return mirror;
  }

  function run() {
    document.querySelectorAll('.mw-accumulated-title').forEach(function (el) {
      var shortened = shorten(el.textContent);
      if (!shortened) { el.style.removeProperty('display'); return; }
      var mirror = getMirror(el);
      if (mirror.textContent !== shortened) mirror.textContent = shortened;
      el.style.display = 'none';
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    [500, 1000, 2000, 3500].forEach(function (delay) { setTimeout(run, delay); });

    // Fallback in case the widget's own container class isn't present/matched:
    // observe the whole document so a later swatch change is still caught.
    var apoNode = document.querySelector('.mw-apo-container') || document.body;
    new MutationObserver(function () { run(); }).observe(apoNode, { childList: true, subtree: true, characterData: true });

    // Primary trigger: swatch selection doesn't always mutate the DOM in a way the
    // observer above reliably catches (e.g. the app may only update an attribute or
    // re-render asynchronously), so also rescan directly on user interaction.
    document.addEventListener('click', function (e) {
      if (e.target.closest('.mw-option, .mw-swatch, .mw-option__control, .mw-stack__item--swatch, .mw-option__value')) {
        setTimeout(run, 80);
        setTimeout(run, 300);
      }
    });

    document.addEventListener('change', function (e) {
      if (e.target.closest('.mw-option, .mw-option__control')) {
        setTimeout(run, 80);
        setTimeout(run, 300);
      }
    });
  });
})();


// =============================================================
// SECTION 11: SELECTED OPTION VALUE SKU (from APO inventory settings)
// Shows the SKU set under "Inventory & Shipping" in the APO admin for each
// selected option value. Rendered in its own element instead of APO's
// "Show selected value SKU" setting, which would add the SKU to
// .mw-accumulated-title and break the title parsing in sections 1A, 2 and 10.
// =============================================================
(function () {
  if (window.location.pathname.indexOf('/products/') === -1) return;

  var valuesById = null;

  function loadValues() {
    var prefetch = window.mwApoOptionsPrefetch;
    var request = prefetch && prefetch.promise
      ? prefetch.promise.then(function (res) { return res.data; })
      : fetchOptions();
    return request.then(function (data) {
      valuesById = (data && data.values) || {};
    });
  }

  // Same endpoint the APO prefetch uses; only needed when it was skipped.
  function fetchOptions() {
    var init = window.mwApoInit;
    if (!init || !init.product || !init.cache_hash) return Promise.resolve(null);
    var variantId = new URLSearchParams(window.location.search).get('variant') ||
      (init.product.variants && init.product.variants[0] && init.product.variants[0].id);
    if (!variantId) return Promise.resolve(null);
    var url = 'https://apo-admin.mageworx.com/front/product/' + init.shop_domain + '/' +
      init.cache_hash + '/' + init.product.id + '/' + variantId + '.js';
    return fetch(url).then(function (r) { return r.ok && r.status !== 204 ? r.json() : null; });
  }

  function getSku(valueId) {
    var entry = valuesById && valuesById[valueId];
    var inventory = entry && entry.value && entry.value.inventory;
    return inventory && inventory.enabled && inventory.sku ? inventory.sku.trim() : '';
  }

  function getSelectedSkus(option) {
    var skus = [];
    option.querySelectorAll('select[name^="mw_opts"]').forEach(function (sel) {
      if (sel.value) skus.push(getSku(sel.value));
    });
    option.querySelectorAll('input[name^="mw_opts"]:checked').forEach(function (input) {
      skus.push(getSku(input.value));
    });
    return skus.filter(Boolean);
  }

  function render() {
    if (!valuesById) return;
    document.querySelectorAll('.mw-apo-container .mw-option').forEach(function (option) {
      var skus = option.offsetParent === null ? [] : getSelectedSkus(option);
      var el = option.querySelector('.apo-value-sku');
      if (!skus.length) { if (el) el.remove(); return; }
      if (!el) {
        el = document.createElement('div');
        el.className = 'apo-value-sku';
        option.appendChild(el);
      }
      var text = 'SKU: ' + skus.join(', ');
      if (el.textContent !== text) el.textContent = text;
    });
  }

  // function injectStyle() {
  //   if (document.getElementById('apo-value-sku-style')) return;
  //   var style = document.createElement('style');
  //   style.id = 'apo-value-sku-style';
  //   style.textContent =
  //     '.apo-value-sku{margin-top:6px;font-size:13px;font-family:monospace;color:#555;letter-spacing:.04em;}';
  //   document.head.appendChild(style);
  // }

  function init() {
    if (!document.querySelector('.mw-apo-container')) return;
    injectStyle();
    loadValues().then(render).catch(function (e) { console.warn('[APO value SKU] load failed:', e); });

    function schedule() { setTimeout(render, 80); setTimeout(render, 300); }
    document.addEventListener('change', function (e) { if (e.target.closest('.mw-option')) schedule(); });
    document.addEventListener('click', function (e) { if (e.target.closest('.mw-option')) schedule(); });

    // APO re-renders options when conditional rules show/hide them.
    var container = document.querySelector('.mw-apo-container');
    new MutationObserver(function () { render(); }).observe(container, { childList: true, subtree: true });
  }

  // APO renders its container asynchronously after the page loads.
  var tries = 0;
  (function waitForApo() {
    if (document.querySelector('.mw-apo-container .mw-option')) return init();
    if (++tries < 40) setTimeout(waitForApo, 250);
  })();
})();
